import React from 'react'
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import CONSTANTS from '../../utils/constants'
import CustomTooltip from './CustomTooltip'

const SimplePieChart = ({ data }) => {
  return (
    <div className="pie-chart">
      <ResponsiveContainer width="100%" height="90%">
        <PieChart>
          <Pie data={data} dataKey="count" innerRadius={60} outerRadius={80} paddingAngle={0}>
            {data.map((entry, index) => (
              <Cell key={index} fill={CONSTANTS.COLORS[index % CONSTANTS.COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend height={50} wrapperStyle={{ overflow: 'auto' }} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}

export default SimplePieChart
